import { useContext } from 'react'
import { ThemeContext } from '../../contexts/ThemeContext.context'

const useThemeContext = () => {
  const data = useContext(ThemeContext)
  return data
}

export default useThemeContext
